import { Zone } from "src/interfaces/IZone";
import { httpAuthorizedRequest } from "../httpService";

export type IapMetric = {
  wynd_score: number;
  infection_risk: String;
  clean_air_zones: number;
  cleanest_zone: {
    zone_id: Zone["zone_id"];
    wynd_score: number;
    floor: Zone["floor"];
    zone_name: Zone["zone_name"];
  };
  air_exchange: {
    [key: string]: number;
  };
};

export type IapMetrics = {
  [propertyName: string]: IapMetric;
};

const getIAQMetrics = (client_dbname: string) =>
  httpAuthorizedRequest.get<IapMetrics>("/iaq", {
    params: { dbn: client_dbname },
  });

// eslint-disable-next-line import/prefer-default-export
export { getIAQMetrics };
